import { Modal } from 'antd';

import { MODAL_FOOTER_BUTTON_SIZE, MODAL_WIDTHS } from '@/shared/lib/constants';
import { Button } from '@/shared/ui/Button';
import { Icon } from '@/shared/ui/Icon';

import styles from '@/features/connectors/ui/_internal/connectorModal.module.css';

type ResetModalProps = {
  open: boolean;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ResetModal = ({ open, description, onConfirm, onCancel }: ResetModalProps) => {
  const footer = (
    <>
      <Button variant="outlined" color="standard" onClick={onCancel} {...MODAL_FOOTER_BUTTON_SIZE}>
        취소
      </Button>
      <Button variant="filled" color="standard" onClick={onConfirm} {...MODAL_FOOTER_BUTTON_SIZE}>
        확인
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      centered
      closable={false}
      title={null}
      footer={footer}
      width={MODAL_WIDTHS.CONFIRM_ALERT}
      onCancel={onCancel}>
      <div className={styles.popupBody}>
        <div className={styles.popupIcon}>
          <Icon name="fail" size={32} />
        </div>
        <p className={styles.popupDescription}>{description}</p>
      </div>
    </Modal>
  );
};
